import { useUserData } from '@/app/queries/MeetingQuery/context';

import Logo from '@/components/Logo';

export default function Title() {
  const userData = useUserData();

  return (
    <div className="flex min-w-0 flex-1 flex-col gap-0.5">
      {/* The wordmark the lobby opens with, rather than a second piece of
          branding invented for this screen. It reads "Ergeon" already, so the
          line that used to spell that out gives its place to the address and
          stays only for the document outline. The plain wrapper keeps the
          stretch of a flex column off the logo. */}
      <h1 className="sr-only">Onsite with Ergeon</h1>
      <div>
        <Logo />
      </div>
      <p className="truncate text-xs text-slate-300">
        {userData.address}
      </p>
    </div>
  );
}
